"use client"

import styled from "@emotion/styled"
import { APIProvider, AdvancedMarker, Map, Pin } from "@vis.gl/react-google-maps"
import { Container } from "ui"
import { Address } from "utils/projects"

const APIKEY = "AIzaSyD2AanBqJJ8WM8JL6LJ3jjbYkUgD4Mk0Cc"
const MAPID = "40df340c1a7a4582"
// const position = { lat: 32.109333, lng: 34.855499 }

const StyledPadding = styled.div`
  padding-top: 32px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
  }
`

const StyledMapContainer = styled.div<{
  locale: string
  padding?: number
  mobileBorderRadius?: string
  desktopBorderRadius?: string
  desktopHeight?: string
  mobileHeight?: string
}>`
  width: 100%;
  height: ${({ mobileHeight }) => mobileHeight || "328px"};
  border-radius: ${(props) => props.mobileBorderRadius || "16px"};
  overflow: hidden;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: ${({ desktopHeight }) => desktopHeight || "500px"};
    border-radius: ${(props) => props.desktopBorderRadius || "16px"};
  }
  .gmnoprint {
    z-index: 99999999;

    right: ${(p) => (p.locale === "he" ? "6px !important" : "unset !important")};
    left: ${(p) => (p.locale === "en" ? "6px !important" : "unset !important")};

    > div {
      border-radius: 8px !important;
    }
    img {
      width: 16px !important;
      height: 16px !important;
    }
    button {
      border-radius: 8px !important;
    }
  }
`

type Props = {
  address?: Address
  locale: string
  mapContainerProps?: Record<string, any>
}

function GoogleMap({ address, locale, mapContainerProps }: Props) {
  let position = { lat: 32.109333, lng: 34.855499 }
  if (address && !address.isEmpty) {
    position = { lat: address.latitude, lng: address.longitude }
  }
  return (
    <APIProvider apiKey={APIKEY} language={locale === "he" ? "iw" : "en"}>
      <Container id="mapContainer" padding={mapContainerProps?.padding || undefined} forSwiper>
        <StyledPadding>
          <StyledMapContainer locale={locale} {...mapContainerProps}>
            <Map
              defaultZoom={15}
              mapId={MAPID}
              defaultCenter={position}
              disableDefaultUI={true}
              zoomControl
              zoomControlOptions={{ position: 10 }}
            >
              <AdvancedMarker position={position}>
                <Pin
                  // background="grey"
                  // glyphColor={"purple"}
                  borderColor={"green"}
                />
              </AdvancedMarker>
            </Map>
          </StyledMapContainer>
        </StyledPadding>
      </Container>
    </APIProvider>
  )
}

export default GoogleMap
